import { render, staticRenderFns } from "./FilterAmountContainer.vue?vue&type=template&id=8dea1524&scoped=true&"
import script from "./FilterAmountContainer.vue?vue&type=script&lang=ts&"
export * from "./FilterAmountContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea1524",
  null
  
)

export default component.exports